import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Popup,
  Heading,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const OfferPopup = ({
  offerText,
  isOpened,
  onClose,
}) => (
  <Popup
    opened={isOpened}
    onClose={onClose}
  >
    <Heading level={1}>
      <I18n path="settings.common.offerTitle" />
    </Heading>
    <div
      className={cx('offerContent')}
      dangerouslySetInnerHTML={{ __html: offerText }}
    />
  </Popup>
);

OfferPopup.propTypes = {
  offerText: PropTypes.string,
  isOpened: PropTypes.bool,
  onClose: PropTypes.func,
};

export default OfferPopup;
